import Service from './payment-service';
import QRCode from 'qrcodejs2';
import { successMessage, errorMessage } from '@/utils/message.js';

export default {
  props: {
    currentProjectId: {
      type: Number,
      default: null
    },
    paymentType: {
      type: String,
      default: 'announcementFee'
    },
    type: {
      type: String,
      default: '2'
    }
  },
  data() {
    return {
      timer: null,
      payStatus: 'init',
      paymentInfo: {},
      paySuccessInfo: {},
      title: ''
    };
  },
  created() {
    this.formateData();
    this.getPaymentInfo();
  },
  beforeDestroy () {
    clearInterval(this.timer);
  },
  computed: {
  },
  methods: {
    formateData () {
      if (this.paymentType === 'announcementFee') {
        this.productName = '项目公告费';
        this.transactionType = 1;
        this.title = '支付公告费';
      } else if (this.paymentType === 'fileFee') {
        this.productName = '采购文件费';
        this.transactionType = 4;
        this.title = '支付采购文件费';
      }
    },
    // 查看采购文件跳转
    goToFilepage() {
      this.$router.push('/person-center/purchase-business/purchase-file-download/list');
    },
    // 根据url转换二维码
    qrcode(url) {
      new QRCode('qrcode', {
        width: 320,
        height: 320,
        text: url
      });
    },
    // 获取支付公告费信息
    getPaymentInfo() {
      const params = {
        productName: this.productName,
        id: this.currentProjectId,
        transactionType: this.transactionType,
        type: this.type
      };
      Service.getPaymentInfo(params).then(res => {
        if (res.code === '0') {
          this.paymentInfo = res.data;
          this.$nextTick(() => {
            this.qrcode(res.data.codeUrl);
          });
          this.timer = setInterval(() => {
            this.getPaymentResult(res.data.transactionNo);
          }, 3000);
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage( '获取信息失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('获取信息失败');
        }
      });
    },
    // 获取VX交易结果
    getPaymentResult(transactionNo) {
      Service.getPaymentResult(transactionNo, this.transactionType).then(res => {
        if (res.code === '0') {
          if (!res.data) {return; }
          if (res.data.status === 1) {
            this.payStatus = 'onGoing';
          } else if (res.data.status === 2 || res.data.status === 3) {
            this.payStatus = res.data.status === 3?'success':'failed';
            if (res.data.status === 3) {
              this.paySuccessInfo = res.data;
              this.$emit('paymentSuccess');
              successMessage('支付成功');
            } else {
              errorMessage('支付失败');
            }
            clearInterval(this.timer);
          }
        } else {
          let message = res && res.reason?res.reason:'获取支付结果失败';
          clearInterval(this.timer);
          errorMessage(message);
        }
      }, (error) => {
        let message = error && error.data && error.data.reason?error.data.reason:'获取支付结果失败';
        clearInterval(this.timer);
        errorMessage(message);
      });
    }
  }
};
